import { Component } from "react";

/**
 * App-level error boundary. Catches unhandled render errors and
 * shows a friendly fallback instead of a white screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[Denbaya] Uncaught error:", error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-bg flex items-center justify-center p-6">
        <div className="max-w-[420px] text-center font-sans">
          <div className="w-14 h-14 rounded-xl bg-gold-50 flex items-center justify-center mx-auto mb-4 text-2xl">
            ⚠
          </div>
          <h2 className="font-serif text-xl font-semibold text-text-base mb-2">
            Une erreur est survenue
          </h2>
          <p className="text-sm text-text-muted leading-normal mb-5">
            Quelque chose s'est mal passé. Vous pouvez essayer de recharger la
            page ou revenir en arrière.
          </p>
          {import.meta.env.DEV && this.state.error && (
            <pre className="text-[11px] text-danger bg-surface border border-border rounded-md p-3 mb-4 text-left whitespace-pre-wrap break-words max-h-40 overflow-auto">
              {this.state.error.message}
            </pre>
          )}
          <div className="flex gap-2 justify-center">
            <button
              onClick={this.handleReset}
              className="px-5 py-2.5 border border-border-strong rounded-md bg-surface text-text-base text-sm font-medium cursor-pointer font-sans hover:bg-gold-50"
            >
              Réessayer
            </button>
            <button
              onClick={this.handleReload}
              className="px-5 py-2.5 border-none rounded-md bg-gold-500 text-white text-sm font-medium cursor-pointer font-sans hover:bg-gold-700"
            >
              Recharger la page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
